import React, { useState } from 'react';
import { PlayerState } from '../common/logic';
import { round, scalarMultiply, ones, sum } from '../common/math';

interface OfferBuilderProps {
	username: string;
	play: PlayerState;
	onOffer: (split: number[]) => void;
	onCancel: () => void;
}

function OfferBuilder({ username, play, onOffer, onCancel }: OfferBuilderProps) {
	function fmt(n: number): string {
		return round(n * 100, 2).toString()
	}

	const players = play.players;
	const n = players.length;
	const [split, setSplit] = useState(scalarMultiply(1/n, ones(n)));
	const [input, setInput] = useState(split.map(fmt));
	const [valid, setValid] = useState(true);

	function onChange(i: number, x: string) {
		const newInput = input.slice();
		newInput[i] = x;
		setInput(newInput);

		const newSplit = split.slice();
		console.log('onChange', x);
		const value = round(Number(x), 2) / 100;
		if (isNaN(value)) {
			setValid(false);
			return;
		}
		newSplit[i] = value;
		setSplit(newSplit);

		const newValid = sum(newSplit) == 1;
		setValid(newValid);
	}

	function normalise(i: number, offer: number[]): number[] | null {
		let newSplit = offer.slice();
		newSplit[i] = 0;
		const sum_ = sum(newSplit);
		if (isNaN(sum_))
			return null;
		if (sum_ == 0)
			return null;
		const scale = (1 - split[i]) / sum(newSplit);
		newSplit = scalarMultiply(scale, newSplit)
			   .map((x: number) => round(x, 4));
		newSplit[i] = 1 - sum(newSplit);
		if (newSplit.some(x => x < 0))
			return null;
		return newSplit;
	}

	function onNormalise(i: number) {
		const newSplit = normalise(i, split);
		if (newSplit == null)
			return;
		setSplit(newSplit);
		setInput(newSplit.map(fmt));
		setValid(true);
	}

	const rows = players.map((playerName: string, i: number) =>
		<tr key={i}>
		<td>{playerName}</td>
		<td> <input className="percentInput" type="text"
			    value={input[i]}
		            onChange={ ev => { onChange(i, ev.target.value) } }
		     />
		     %
		</td>
		<td> <button onClick={() => onNormalise(i)}>
			↺= &nbsp; 100%
		     </button>
		</td>
		</tr>
	);

	return (
		<>
		<p>Select a split to offer:</p>
		<table>
		<tr> <th>Player</th> <th>Split</th> <th></th> </tr>
		{rows}
		</table>
		<button disabled={!valid} onClick={() => onOffer(split)}>
			✓ &nbsp; Propose
		</button>
		<button onClick={onCancel}> ✗ &nbsp; Cancel </button>
		</>
	);
}

interface MoveBarProps {
	username: string;
	play: PlayerState;
	onSendMessage: (msg: string) => void;
	onShowdown: () => void;
	onOffer: (split: number[]) => void;
}

export default function MoveBar(props: MoveBarProps) {
	const { username, play, onSendMessage, onShowdown, onOffer } = props;
	const [msg, setMsg] = useState("");
	const [showOfferBuilder, setShowOfferBuilder] = useState(false);

	function onClickSend(e: React.MouseEvent<HTMLButtonElement>): void {
		e.preventDefault();
		onSendMessage(msg);
		setMsg("");
	}

	function onClickNewOffer(e: React.MouseEvent<HTMLButtonElement>): void {
		e.preventDefault();
		setShowOfferBuilder(true);
	}

	function onClickShowdown(e: React.MouseEvent<HTMLButtonElement>): void {
		e.preventDefault();
		onShowdown();
	}

	function onOffer_(split: number[]) {
		setShowOfferBuilder(false);
		onOffer(split);
	}

	function onCancelOffer() {
		setShowOfferBuilder(false);
	}

	const offerBuilderProps = {
		username, play, onOffer: onOffer_, onCancel: onCancelOffer };
	let offerBuilder = <OfferBuilder {...offerBuilderProps} />;
	if (!showOfferBuilder)
		offerBuilder = <> </>;

	return(
		<div className="MoveBar">
		{offerBuilder}
		<form style={{ display: 'flex' }}>
			<input type="text" value={msg} autoFocus
			       style={{ flex: 'auto', margin: '10px 0 5px 5px' }}
			       onChange={e => setMsg(e.target.value)}/>
			<button type="submit"
				style={{ flex: 'none', margin: '10px 5px 5px 0' }}
			        onClick={onClickSend}>
				➢ &nbsp; Send
			</button>
		</form>
		<button onClick={onClickNewOffer}>
			+ &nbsp; New offer
		</button>
		<button onClick={onClickShowdown}>
			⚡&nbsp; Showdown
		</button>
		</div>
	);
}


